import { ParamIds, Places } from '../../../Constants'
import BorderoKeys from '../bordero.keys'

export class ResultadoAnaliseKeys extends BorderoKeys {
    get place() {
        return Places.resultadoAnalise
    }

    get borderoId() {
        return this._intent.getParameterAsNumber(ParamIds.borderoFormId)
    }

    set borderoId(value: number | undefined) {
        this._intent.setParameter(ParamIds.borderoFormId, value)
    }
}
